"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVestingAminoConverters = void 0;
function createVestingAminoConverters() {
    return {
        "/cosmos.vesting.v1beta1.MsgCreateVestingAccount": "not_supported_by_chain",
    };
}
exports.createVestingAminoConverters = createVestingAminoConverters;
//# sourceMappingURL=aminomessages.js.map